// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

interface SessionMetricsLabels {
  geography: string;
  device: string;
}

export const SessionMetrics = {
  /**
   * Records a session creation metric by calling the server-side metrics API
   * @param labels Object containing geography and device information
   */
  async incrementSessionCreated(labels: SessionMetricsLabels): Promise<void> {
    // Only track in browser environment
    if (typeof window === 'undefined') {
      return;
    }

    try {
      const response = await fetch('/api/metrics', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          geography: labels.geography,
          device: labels.device
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Failed to record session metric:', {
          status: response.status,
          statusText: response.statusText,
          error: errorData
        });
      } else {
        console.log('Session metric recorded successfully');
      }
    } catch (error) {
      console.error('Error calling session metrics API:', error);
    }
  }
};
